module.exports = __webpack_public_path__ + "img/appltCourse-img23.0007e7b8.png";